import { useQuery } from "@tanstack/react-query";

import {
    groupTechnologiesByType,
    toGroupedTechnologiesCategoryMap,
} from "app/pages/sales-intelligence/domain/technology/utils/grouping";

import type { TechnologiesDescriptionDto } from "../types/dto";

import { createDescriptionQuery } from "./options";

const select = ({ technologies }: TechnologiesDescriptionDto) =>
    toGroupedTechnologiesCategoryMap(groupTechnologiesByType(technologies));

export default function useGroupedTechnologiesCategoryMapQuery() {
    return useQuery(
        createDescriptionQuery({
            select,
        }),
    );
}
